import { isEmpty } from 'lodash';

import removeMask, { removeCpfCnpjMask } from './removeMask';

const maskFieldValidator = (rule, value, type) => {
  const realValue =
    type === 'CNPJ'
      ? removeCpfCnpjMask(String(value))
      : removeMask(String(value));

  if (isEmpty(realValue)) {
    // callback();
    return Promise.resolve();
  }

  const { min, max, message } = rule;

  if (realValue.length < min || realValue.length > max)
    return Promise.reject(new Error(message));

  return Promise.resolve();
};

export default maskFieldValidator;
